import * as _ from 'lodash'
import fetchBasicActionsFor from '../fetch/basicActionsFor'

function selectorBasicActionsFor(resourceName: string, prefix?: string) {
  if (resourceName === null) throw new Error('fetchBasicActionsFor: Expected resourceName')

  const resource = resourceName.trim()
  if (resource === '') throw new Error('fetchBasicActionsFor: Expected resourceName')

  const upperResource = _.snakeCase(resource).toUpperCase()

  const fetchActionTypes = fetchBasicActionsFor(resourceName, prefix);
  const selectedResourceActionType = `${prefix ? prefix.toUpperCase() + '/' : ''}${upperResource}_SELECTED`
  const selectedResourcesActionType = `${prefix ? prefix.toUpperCase() + '/' : ''}${upperResource}_MULTI_SELECTED`

  const result = {
    ...fetchActionTypes,
    resourceSelected: selectedResourceActionType,
    resourcesSelected: selectedResourcesActionType
  }

  return {...result}
}

export default selectorBasicActionsFor
